import HomeHero from '../../components/User/Home/HomeHero'
import AboutUs from '../../components/User/Home/AboutUs'
import Services from '../../components/User/Home/Services'
import Percentage from '../../components/User/Home/Percentage'
import ItSolutions from '../../components/User/Home/ItSolutions'
import Awards from '../../components/User/Home/Awards'
import Testimonials from '../../components/User/Home/Testimonials'
import Partners from '../../components/User/Home/Partners'
import Blog from '../../components/User/Home/Blog'
import News from '../../components/User/Home/News'
import LifeAtNatio from '../../components/User/Home/LifeAtNatio'

const Home = () => {
  return (
    <div className='overflow-hidden'>
      <HomeHero />
      <AboutUs />
      <Services />
      <Percentage />
      <ItSolutions />
      <Awards />
      <Testimonials />
      <Partners />
      <Blog />
      {/* <News /> */}
      <LifeAtNatio />
    </div>
  )
}

export default Home